class AssistantFeedbacks {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/feedbacks`;

  }

  getFeedbacks(paginationOptions) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, { paginationOptions });

  }

  createFeedback(data) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, data);

  }

  analyzeFeedback(feedbackId, data) {

    const path = `${this.basePath}/:feedbackId/analyze`;

    return this.apiClient.post(path, { feedbackId }, {}, data);

  }

  applySuggestion(feedbackId, suggestionId) {

    const path = `${this.basePath}/:feedbackId/suggestions/:suggestionId/apply`;

    return this.apiClient.post(path, { feedbackId, suggestionId }, {}, {});

  }

  applyFeedbackSuggestions(feedbackId) {

    const path = `${this.basePath}/:feedbackId/apply-suggestions`;

    return this.apiClient.post(path, { feedbackId }, {}, {});

  }

  deleteFeedback(feedbackId) {

    const path = `${this.basePath}/:feedbackId`;

    return this.apiClient.delete(path, { feedbackId });

  }

}

export default AssistantFeedbacks;